import * as parentConstants from 'modules/client-admin/ClientsPage/constants';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import Page from 'modules/Page';
import { toTitleCase } from 'utils';
import { i18n } from 'i18n';
import * as constants from './constants';
import { EditClientPageParams } from './constants';
import useEditClientQueries, { EditClientQueries } from './useEditClientQueries';

const EditClientPage = lazyWithSuspense(() => import('./EditClientPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: true,
  component: makePage<EditClientPageParams, EditClientQueries>({
    WrappedPage: EditClientPage,
    titleFn: ([client]) => (client.data ? i18n._(toTitleCase(client.data.name)) : ''),
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
    pageDataHook: useEditClientQueries,
  }),
};

export default page;
